module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('form', [(_vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "existing-user"
    }
  }, [_vm._v("Select existing user")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUser),
      expression: "selectedUser"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "existing-user",
      "id": "existing-user"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select User")]), _vm._v(" "), _vm._l((_vm.users), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.email
      }
    }, [_vm._v(_vm._s(option.email))])
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.selectedUser && _vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerFirstName),
      expression: "project.customerFirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Steve"
    },
    domProps: {
      "value": (_vm.project.customerFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerFirstName", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.selectedUser && _vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "surname"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerLastName),
      expression: "project.customerLastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surname",
      "id": "surname",
      "placeholder": "Jobs"
    },
    domProps: {
      "value": (_vm.project.customerLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerLastName", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerCompanyName),
      expression: "project.customerCompanyName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "company",
      "id": "company",
      "placeholder": "Apple"
    },
    domProps: {
      "value": (_vm.project.customerCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerCompanyName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.selectedUser && _vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerEmail),
      expression: "project.customerEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "steve@apple.com"
    },
    domProps: {
      "value": (_vm.project.customerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerEmail", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.selectedUser && _vm.args.userRole !== 'customer') ? _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.customerPasswordPlainText),
      expression: "project.customerPasswordPlainText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.project.customerPasswordPlainText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "customerPasswordPlainText", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center mt20"
  }, [_c('button', {
    staticClass: "btn btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabledSubmit
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onProjectCreate($event)
      }
    }
  }, [_vm._v("Submit")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1af98136","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/modals/ProjectCreateModal.vue
// module id = 426
// module chunks = 2